module.exports = __webpack_public_path__ + "static/media/farmers_market_stand.628b69cd.jpeg";